<mat-slide-toggle
  color="primary"
  ixTest="row-toggle"
  [checked]="checked"
  (change)="onSlideToggleChanged($event)"
  (click)="$event.stopPropagation()"
></mat-slide-toggle>
